export default __webpack_public_path__ + "static/media/ic-png.c7e81876.svg";